"use client";

import { useEffect } from "react";

// Schuift een horizontale keuzerij naar de knop die aan staat.
//
// De klassen staan op tijd, dus wat nu rijdt schuift in de loop van de dag naar
// rechts. Om zes uur 's avonds stond de klasse die op dat moment op de baan was
// vijf pillen buiten beeld: je moest vegen om te zien waar je naar keek, en tot
// die tijd leek de eerste klasse van de ochtend de belangrijkste.
//
// Alleen scrollLeft van de rij zelf, niet scrollIntoView: die laatste trekt ook
// de pagina verticaal mee, en dan springt het scherm bij het laden weg van waar
// je stond.
export function KiezerNaarActief({ sleutel }: { sleutel: string }) {
  useEffect(() => {
    for (const rij of document.querySelectorAll<HTMLElement>("[data-kiezerrij]")) {
      const actief = rij.querySelector<HTMLElement>("[data-kiezeractief]");
      if (!actief) continue;

      // Midden in beeld, of zo dicht mogelijk daarbij: staat de knop vooraan of
      // achteraan, dan begrenst de browser het vanzelf.
      const doel = actief.offsetLeft - (rij.clientWidth - actief.clientWidth) / 2;
      rij.scrollTo({ left: Math.max(0, doel), behavior: "instant" });
    }
    // Sleutel als afhankelijkheid: na het kiezen van een andere klasse rendert
    // de pagina opnieuw en moet de rij mee.
  }, [sleutel]);

  return null;
}
